var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDollarSign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.16346C8 5.38801 1.92 6.98586 1.92 4.58201C1.92 3.74774 2.69714 3.21041 3.97714 3.21041C5.28762 3.21041 6.14095 3.875 6.24762 4.8931H7.78667C7.66476 3.29525 6.47619 2.17817 4.69333 1.95192V0.75H3.36762V1.93778C1.55429 2.12161 0.335238 3.15385 0.335238 4.58201C0.335238 8.2302 6.38476 6.80204 6.38476 9.1776C6.38476 10.2523 5.40952 10.733 4.06857 10.733C2.56 10.733 1.66095 9.9129 1.53905 8.64027H0C0.106667 10.4785 1.37143 11.7511 3.36762 11.9915V13.2359L4.69333 13.25V12.0057C6.64381 11.8218 8 10.8037 8 9.16346Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarSign);
export default __webpack_public_path__ + "static/media/DollarSign.01ccc0b451abdd0e317b263e9b629a66.svg";
export { ForwardRef as ReactComponent };